/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface CancelBooking$Params {
  recourseBookingId: number;
}

export function cancelBooking(
  http: HttpClient,
  rootUrl: string,
  params: CancelBooking$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, cancelBooking.PATH, 'patch');
  if (params) {
    rb.path('recourseBookingId', params.recourseBookingId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    }),
  );
}

cancelBooking.PATH = '/service/v1/recoursebooking/cancelbooking/{recourseBookingId}';
